import React, { useEffect, useState } from "react";
import { Button, Table, Empty } from "antd";
import editIcon from "../../Assets/Images/edit-icon.svg";
import deleteIcon from "../../Assets/Images/delete-icon.svg";
import { useNavigate } from "react-router-dom";
import tableCellRender from "../../Components/TableCellRender/tableCellRender";
import { userServices } from "../../Services/API/userServices";
import { sessionServices } from "../../Utils/SessionServices";
import Loader from "../../Components/Loader/Loader";
import { toast } from "react-toastify";
import AlertModal from "../../Components/AlertModal/AlertModal";

export default function GSAListing() {
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [gsaList, setGsaList] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState("");

  useEffect(() => {
    getAllGsaList();
  }, []);

  const getAllGsaList = async (showLoader = true) => {
    try {
      setLoader(showLoader);
      const accessToken = await sessionServices?.getSessionStorageItem("token");
      const resp = await userServices.getUserBasedOnRole(accessToken, "GSA");
      setGsaList(resp?.data);
    } catch (error) {
      console.log("err", error);
    } finally {
      setLoader(false);
    }
  };

  const deleteUser = async (id) => {
    try {
      const resp = await userServices?.deleteUser(id);
      if (resp?.status === 200) {
        toast.success("Deleted Successfully");
        getAllGsaList(false);
      }
    } catch (error) {
      console.log("error", error);
      toast.error(`${error?.response?.data || 'Something went wrong'}`);
    } finally {
      setShowDeleteModal("");
    }
  };

  const columns = [
    {
      title: "First Name",
      dataIndex: "firstName",
      key: "firstName",
      fixed: 'left',
      sorter: (a, b) => a.firstName.localeCompare(b.firstName),
      render: (value) => {
        return tableCellRender(value, "single-val");
      },
    },
    {
      title: "Last Name",
      dataIndex: "lastName",
      key: "lastName",
      sorter: (a, b) => a.lastName.localeCompare(b.lastName),
      render: (value) => {
        return tableCellRender(value, "single-val");
      },
    },
    {
      title: "Phone Number",
      dataIndex: "phoneNo",
      key: "phoneNo",
      render: (value) => {
        return tableCellRender(value, "single-val");
      },
    },
    {
      title: "Location",
      dataIndex: "location",
      key: "location",
      sorter: (a, b) => a.location.localeCompare(b.location),
      render: (value) => {
      console.log('value',value);
      const location = value != 'null' ? value : ''
        return tableCellRender(location, "single-val");
      },
    },
    {
      title: "Email Id",
      dataIndex: "email",
      key: "email",
      sorter: (a, b) => a.email.localeCompare(b.email),
      render: (value) => {
        return tableCellRender(value, "single-val");
      },
    },
    {
      title: " ",
      dataIndex: "",
      key: "",
      width: 120,
      render: (value, row) => {
        return (
          <div className="actions-div">
            <div className="edit-GSA-container">
              <img
                className="actions-icons"
                src={editIcon}
                onClick={() =>
                  navigate("/gsa", {
                    state: { action: "edit", data: value },
                  })
                }
                alt="Edit GSA"
              />
            </div>
            <div
              className="delete-GSA-container"
              onClick={() => {
                setShowDeleteModal(value?.uid);
              }}
            >
              <img
                className="actions-icons"
                src={deleteIcon}
                alt="Delete GSA"
              />
            </div>
          </div>
        );
      },
    },
  ];

  return (
    <>
      {loader ? (
        <Loader />
      ) : (
        <div className="listing-page">
          <div className="listing-header-container">
            <div className="heading">GSA</div>
            <div className="add-btn-container">
              <Button
                className="add-btn"
                onClick={() =>
                  navigate("/gsa", {
                    state: { action: "add", data: "" },
                  })
                }
              >
                Add New GSA
              </Button>
            </div>
          </div>
          {gsaList?.length ? (
            <div className="table-container">
              <Table
                className="table-class"
                columns={columns}
                dataSource={gsaList}
                scroll={{
                  x: 'auto',
                }}
              />
            </div>
          ) : (
            <div className="no-data">
              <Empty />
            </div>
          )}
        </div>
      )}
      {showDeleteModal?.length ? (
        <AlertModal
          openModal={showDeleteModal?.length}
          closeModal={() => {
            setShowDeleteModal("");
          }}
          handleYes={() => {
            deleteUser(showDeleteModal);
          }}
          title={"GSA"}
        />
      ):''}
    </>
  );
}
